export default __webpack_public_path__ + "static/media/replit.72d1fbaa.png";